module.exports = __webpack_public_path__ + "img/logo-white.7042a855.png";